import { combineReducers } from "redux";

// login
import LoginReducer from "./auth/login/reducer";

// Front
import LayoutReducer from "./layouts/reducer";

// register
import RegisterReducer from "./auth/register/reducer";

// userProfile
import ProfileReducer from "./auth/profile/reducer";

const rootReducer = combineReducers({
  Login: LoginReducer,
  Layout: LayoutReducer,
  Register: RegisterReducer,
  Profile: ProfileReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
